import React, { useCallback } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { FilterToggleRow } from '../../../common/list/FilterToggleGroup';

// 정렬(사원관리/employeemng 전용, 경로상 "modal"이지만 모달 아님) - 화살표 아이콘이 있어
// FilterToggleGroup(점 전용) 대신 ToggleButtonGroup을 직접 쓴다. 같은 스타일(size small,
// exclusive)만 맞춤(2026-10-22, chancemng 설계 적용).
const orders = [
  { id: 0, value: '', label: '전체' },
  { id: 1, value: 'usrNoAsc', label: '사번', icon: <ArrowDropUpIcon fontSize="small" /> },
  { id: 2, value: 'usrNoDesc', label: '사번', icon: <ArrowDropDownIcon fontSize="small" /> },
  { id: 3, value: 'gradeNmAsc', label: '직급', icon: <ArrowDropUpIcon fontSize="small" /> },
  { id: 4, value: 'gradeNmDesc', label: '직급', icon: <ArrowDropDownIcon fontSize="small" /> },
];

const EmpOrdList = ({ orderName, onChangeOrder }) => {
  const handleChange = useCallback(
    (_event, newValue) => {
      if (newValue === null) return;
      onChangeOrder(newValue);
    },
    [onChangeOrder],
  );

  return (
    <FilterToggleRow>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={orderName}
        onChange={handleChange}
        sx={{
          flexWrap: 'wrap',
          '& .MuiToggleButton-root': { textTransform: 'none', px: 1.1, py: 0.4, lineHeight: 1.4, whiteSpace: 'nowrap' },
        }}
      >
        {orders.map((opt) => (
          <ToggleButton key={opt.value || 'all'} value={opt.value} aria-label={opt.label}>
            {opt.icon}
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FilterToggleRow>
  );
};

export default EmpOrdList;
